import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function(id_integration) {
    const response = await api.fetch(
      `/api/v2/booking/rooms/id_integration/${id_integration}`,
    )
    return await handleResponse(response)
  }
}
